import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=b4d52c4c"
import script from "./todo.vue?vue&type=script&lang=js"
export * from "./todo.vue?vue&type=script&lang=js"
import style0 from "./todo.vue?vue&type=style&index=0&id=b4d52c4c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d52c4c')) {
      api.createRecord('b4d52c4c', component.options)
    } else {
      api.reload('b4d52c4c', component.options)
    }
    module.hot.accept("./todo.vue?vue&type=template&id=b4d52c4c", function () {
      api.rerender('b4d52c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work/todo.vue"
export default component.exports